<template>
    <div>
      <h3>Éditeur des Devises Disponibles</h3>
      <div v-for="(currency, index) in localCurrencies" :key="index" class="currency-item">
        <input
          type="text"
          :value="currency.code"
          @input="updateCurrency(index, 'code', $event.target.value)"
          placeholder="Code de la devise (ex: USD)"
          class="form-control"
        />
        <input
          type="text"
          :value="currency.name"
          @input="updateCurrency(index, 'name', $event.target.value)"
          placeholder="Nom de la devise (ex: Dollar américain)"
          class="form-control"
          style="margin-top: 5px;"
        />
        <button @click="removeCurrency(index)" class="btn btn-danger" style="margin-top: 5px;">
          Supprimer
        </button>
      </div>
      <button @click="addCurrency" class="btn btn-primary" style="margin-top: 10px;">
        Ajouter une devise
      </button>
    </div>
  </template>
  
  <script>
  export default {
    name: "AvailableCurrenciesEditor",
    props: {
      currencies: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        localCurrencies: [...this.currencies], // Copie locale des données
      };
    },
    watch: {
      currencies: {
        handler(newData) {
          this.localCurrencies = [...newData];
        },
        immediate: true,
      },
    },
    methods: {
      updateCurrency(index, field, value) {
        this.localCurrencies[index][field] = value;
        this.$emit("update-currencies", [...this.localCurrencies]);
      },
      addCurrency() {
        this.localCurrencies.push({ code: "", name: "" });
        this.$emit("update-currencies", [...this.localCurrencies]);
      },
      removeCurrency(index) {
        this.localCurrencies.splice(index, 1);
        this.$emit("update-currencies", [...this.localCurrencies]);
      },
    },
  };
  </script>
  
  <style scoped>
  .currency-item {
    margin-bottom: 15px;
  }
  </style>
  